import React, { useState, useEffect } from "react";

// Languages
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

// Routes Info
import routes from "../../../../locales/routes.json";

const RouteLocationDisplayer = ({ hotelName = "" }) => {
  // Translator
  const { t } = useTranslation();

  // States
  const [routeLabel, setRouteLabel] = useState("");
  const [routeLink, setRouteLink] = useState("");
  const [stateHotel, setHotelName] = useState("");

  // Useffects
  useEffect(() => {
    setHotelName(hotelName || "");
    const currentRoute = window.location.pathname.split("/");
    recognaizeRoute(currentRoute[1]);
  }, [hotelName]); // Include hotelName in dependency array to update when it changes

  // --- Functions
  const recognaizeRoute = (currentRoute) => {
    const allRoutes = routes;

    for (let route of allRoutes) {
      if (route.name === currentRoute) {
        setRouteLabel(route.langauge?.he ?? "");
        setRouteLink("/" + route.name);
      }
    }
  };

  return (
    <>
      <div className="routeLocationDisplayer-wrapper">
        {routeLabel?.split("/").length > 1 ? (
          <span>
            <span>
              {" "}
              {routeLabel.split("/")[0] == "מלון"
                ? `${routeLabel.split("/")[0]}/${stateHotel}`
                : routeLabel.split("/")[0]}
              /
            </span>
            <a className="routeLocationDisplayer-link" href={routeLink}>
              {" "}
              {routeLabel.split("/")[1]}{" "}
            </a>
          </span>
        ) : (
          <a className="routeLocationDisplayer-link" href={routeLink}>
            {" "}
            {routeLabel}{" "}
          </a>
        )}
      </div>
    </>
  );
};

export default RouteLocationDisplayer;
